import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";
import { isReadingApp } from "@/lib/readingApp";

export const UpgradeTip = ({ testId }) => (
  <p className="text-xs font-semibold text-green-800 mt-2" data-testid={testId}>
    Tip: 3 subjects (Rs 500) include the Reading kit in English & French for free, instead of Rs 200 per language.
    <span className="block font-normal text-green-700">Astuce : avec 3 matières (Rs 500), le kit Lecture anglais & français est inclus gratuitement.</span>
  </p>
);

// Parents whose child has 1 or 2 subjects: 3 subjects would include the Reading kit.
export function ReadingUpsellBanner({ billing }) {
  const kids = (billing?.children || []).filter((c) => c.paid_subjects.length > 0 && c.paid_subjects.length < 3 && !c.reading_included);
  if (!kids.length) return null;
  return (
    <Link to="/pricing" data-testid="reading-upsell-banner"
      className="mb-6 flex items-center gap-3 rounded-2xl border-2 border-slate-900 bg-sky-100 px-5 py-4 shadow-[4px_4px_0_0_#0F172A] hover:bg-sky-200 transition-colors">
      <img src="/mascot/kiko.png" alt="" className="w-12 h-12" />
      <span className="flex-1 text-sm">
        <b className="flex items-center gap-1.5"><BookOpen size={16} /> Reading kit free with 3 subjects · Kit Lecture offert avec 3 matières</b>
        {kids.map((c) => c.name).join(", ")}: move to 3 subjects (Rs 500/month) and get Reading with Kiko in English & French included.
        <span className="block text-slate-600">Passez à 3 matières (Rs 500/mois) : la Lecture avec Kiko en anglais et en français est incluse.</span>
      </span>
      <span className="font-bold" data-testid="reading-upsell-cta">See plans →</span>
    </Link>
  );
}

// Kid Reading home, when a language is locked: a short note for the parent.
export function ReadingLockedNote({ paidCount }) {
  const few = paidCount > 0 && paidCount < 3;
  if (isReadingApp()) {
    return (
      <div className="mt-8 rounded-3xl border-[3px] border-slate-900 bg-white p-5 shadow-[4px_4px_0_0_#0F172A]" data-testid="reading-locked-parent-note">
        <p className="font-bold">Show this to your parent · Montre ceci à tes parents</p>
        <p className="text-sm mt-1">This Reading kit is not active yet. Parents can activate it from their Anou Appran account.</p>
        <p className="text-sm text-slate-600">Ce kit Lecture n'est pas encore activé. Les parents peuvent l'activer depuis leur compte Anou Appran.</p>
      </div>
    );
  }
  return (
    <div className="mt-8 rounded-3xl border-[3px] border-slate-900 bg-white p-5 shadow-[4px_4px_0_0_#0F172A]" data-testid="reading-locked-parent-note">
      <p className="font-bold">Show this to your parent · Montre ceci à tes parents</p>
      <p className="text-sm mt-1">{few ? "Move to 3 subjects (Rs 500/month): the Reading kit in English & French is included for free." : "The Reading kit is included with 3 subjects (Rs 500/month), all subjects or the Holiday Pack. Or buy it on its own, no subject plan needed: Rs 200 per language per month."}</p>
      <p className="text-sm text-slate-600">{few ? "Passez à 3 matières (Rs 500/mois) : le kit Lecture anglais & français est inclus gratuitement." : "Le kit Lecture est inclus avec 3 matières (Rs 500/mois), toutes les matières ou le Holiday Pack. Ou achetez-le seul, sans matières : Rs 200 par langue et par mois."}</p>
      <Link to="/pricing" className="mt-3 inline-block rounded-full bg-blue-600 text-white border-2 border-slate-900 px-4 py-1.5 text-sm font-bold" data-testid="reading-locked-see-plans">See plans · Voir les formules</Link>
    </div>
  );
}
